import { useState, useContext } from "react";
import { createCategory } from "../../../services/inventory";
import { RequestLoader } from "../../../hooks/context";

const CategoryFormLogic = ({ handleNextStep }) => {
  const [isAddingCategory, setIsAddingCategory] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [categoryDescription, setCategoryDescripion] = useState("");
  const { setRequestLoaderProgress } = useContext(RequestLoader);

  const handleAddCategory = () => {
    setIsAddingCategory(true);
    setRequestLoaderProgress(40);
    createCategory({
      name: categoryName,
      description: categoryDescription,
    })
      .then(() => {
        setIsAddingCategory(false);
        setRequestLoaderProgress(100);
        handleNextStep();
      })
      .catch((error) => {
        setIsAddingCategory(false);
        setRequestLoaderProgress(100);
      });
  };

  return {
    categoryName,
    categoryDescription,
    isAddingCategory,
    setCategoryName,
    setCategoryDescripion,
    handleAddCategory,
  };
};

export default CategoryFormLogic;
